import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import {Link, NavLink, Route, Switch, useHistory, withRouter} from 'react-router-dom';

import Graph from "../../../../components/etc/Graph";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";

import {getDateFormat} from "../../../../utils/functions"

import {BASE_PATH} from "../../../../wpconfig";
import DBasic from "./module/0_Basic";
import DScholar from "./module/1_Scholar";
import DDeptArticle from "./module/3_1_DeptArticle";
import DMajorArticle from "./module/3_2_MajorArticle";
import DeptMajorArticle from "./module/4_DeptMajorArticle";
// import DStatisticsTable from "./module/4_DeptMajorArticle";
// import DStatisticsChart from "./module/5_StatisticsTable";

class DepartmentContent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;

		return (
			<div className="center-group">
				<DBasic record={record}/>
				<DScholar record={record}/>
				{/*<DYearArticle record={record} />*/}
				<DDeptArticle record={record}/>
				<DMajorArticle record={record}/>
				{/*<DeptMajorArticle record={record}/>*/}
				{/*<DStatisticsChart record={record} />*/}
			</div>
		)
	}
}

export default connect(
	(state) => ({
		record: state.departments.record ? state.departments.record : {},
	}),
	(dispatch) => ({
		// dataActions: bindActionCreators(Actions, dispatch)
	}),
)(DepartmentContent)

// DepartmentContent.propTypes = {
// args : PropTypes.object,
// facet : PropTypes.object,
// };
